// extracted by mini-css-extract-plugin
module.exports = {"client-menu":"style-module__client-menu___39yO5"};